import React, { Component, Fragment } from 'react';
import Header from '../NewProfile/Header';
import Footer from './Footer';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import EncourageScroll from '../EncourageScroll';
import { faCheckCircle as circleSolid } from '@fortawesome/pro-solid-svg-icons';
import { faCheckCircle as circleRegular } from '@fortawesome/pro-regular-svg-icons';

import ScrollLock from 'react-scrolllock';

class Progress extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      goToApplication,
      progress,
      message,
      done,
      history
    } = this.props;
    return (
      <Fragment>
        {history.location.pathname.includes('Mobile') ? null : (
          <div className="apply__header">
            <Header title="Application" />
          </div>
        )}
        <ScrollLock>
          <EncourageScroll className="apply__progress">
            <div className="apply__progress--container">
              <div className="apply__body--title">Steps</div>
              <div className="apply__progress--message">{message}</div>
              <div className="apply__progress--status">
                {progress.steps.map((element, index) =>
                  index < 4 ? (
                    <div
                      className={`apply__progress--item ${
                        element.status
                          ? 'apply__progress--item-complete'
                          : ''
                      }`}
                      onClick={() => {
                        element.status ? goToApplication(index) : null;
                      }}>
                      <div className="apply__progress--icon">
                        <FontAwesomeIcon
                          icon={
                            element.status ? circleSolid : circleRegular
                          }
                          size="lg"
                        />
                      </div>
                      <div
                        className={`apply__progress--text ${
                          element.status
                            ? 'apply__progress--text-bold'
                            : ''
                        }`}>
                        {element.name}
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`apply__progress--item ${
                        element.status
                          ? 'apply__progress--item-complete'
                          : ''
                      }`}
                      onClick={() => {
                        done ? goToApplication(index) : null;
                      }}>
                      <div className="apply__progress--icon">
                        <FontAwesomeIcon
                          icon={
                            element.status ? circleSolid : circleRegular
                          }
                          size="lg"
                        />
                      </div>
                      <div
                        className={`apply__progress--text ${
                          element.status
                            ? 'apply__progress--text-bold'
                            : ''
                        }`}>
                        {element.name}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </EncourageScroll>
        </ScrollLock>
        <Footer
          active
          next
          label={
            progress.started ? 'Continue Application' : 'Start Application'
          }
          onNextClick={() => goToApplication(progress.nextStep)}
        />
      </Fragment>
    );
  }
}

export default Progress;



// WEBPACK FOOTER //
// ./src/components/TorontoApply/Progress.js